export enum PurchaseViewFrom {
  CASH_BOX_REPORTING = "CASH_BOX_REPORTING",
  CASH_BOX_ADMINISTRATION = "CASH_BOX_ADMINISTRATION",
  ADMINISTRATION_PANEL = "ADMINISTRATION_PANEL",
  LIQUIDATION_REPORTING = "LIQUIDATION_REPORTING",
  LIQUIDATION_ADMINISTRATION = "CASH_BOX_ADMINISTRATION",
}